import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tiles-container" }
const _hoisted_2 = { class: "tiles-text" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-overline mb-1",
  style: {"visibility":"hidden"}
}, "filler", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6 mb-1" }, "Total Assigned ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, " Currently assigned seats ", -1)
const _hoisted_6 = { class: "text-h4" }
const _hoisted_7 = { class: "tiles-text" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-overline mb-1",
  style: {"visibility":"hidden"}
}, "filler", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6 mb-1" }, "Assigned But Never Used", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, " No show seats ", -1)
const _hoisted_11 = { class: "text-h4" }
const _hoisted_12 = { class: "tiles-text" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-overline mb-1",
  style: {"visibility":"hidden"}
}, "filler", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6 mb-1" }, "No Activity in the Last 7 days ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text-caption" }, " No use in the last 7 days ", -1)
const _hoisted_16 = { class: "text-h4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", null, "All assigned seats ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_card, {
        elevation: "4",
        color: "white",
        variant: "elevated",
        class: "mx-auto my-3",
        style: {"width":"300px","height":"175px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_item, { class: "d-flex justify-center align-center" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _hoisted_4,
                _hoisted_5,
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.totalSeats.length), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        elevation: "4",
        color: "white",
        variant: "elevated",
        class: "mx-auto my-3",
        style: {"width":"300px","height":"175px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_item, { class: "d-flex justify-center align-center" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _hoisted_9,
                _hoisted_10,
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.NoshowSeats.length), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        elevation: "4",
        color: "white",
        variant: "elevated",
        class: "mx-auto my-3",
        style: {"width":"300px","height":"175px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_item, { class: "d-flex justify-center align-center" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _hoisted_14,
                _hoisted_15,
                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.unusedSeats.length), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_v_main, {
        class: "p-1",
        style: {"min-height":"300px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, {
            style: {"min-height":"300px"},
            class: "px-4 elevation-2"
          }, {
            default: _withCtx(() => [
              _hoisted_17,
              _hoisted_18,
              _hoisted_19,
              _createVNode(_component_v_data_table, {
                headers: _ctx.headers,
                items: _ctx.totalSeats,
                "items-per-page": 10,
                class: "elevation-2"
              }, {
                item: _withCtx(({ item, index }) => [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                    _createElementVNode("td", null, _toDisplayString(item.login), 1),
                    _createElementVNode("td", null, _toDisplayString(item.id), 1),
                    _createElementVNode("td", null, _toDisplayString(item.team), 1),
                    _createElementVNode("td", null, _toDisplayString(item.created_at), 1),
                    _createElementVNode("td", null, _toDisplayString(item.last_activity_at), 1),
                    _createElementVNode("td", null, _toDisplayString(item.last_activity_editor), 1)
                  ])
                ]),
                _: 1
              }, 8, ["headers", "items"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}